export const Divider = () => <div data-testid="atom-divider" className="my-5 w-full border border-gray-700" />;
export default Divider;